import { Operator } from "../enums";
import { DatalligatorOperator } from "./types";

export function getDatalligatorOperator(
  operator: Operator
): DatalligatorOperator {
  switch (operator) {
    case Operator.CONTAINS:
      return DatalligatorOperator.contains;
    case Operator.EQUALS:
      return DatalligatorOperator.equals;
    case Operator.GTE:
      return DatalligatorOperator.gte;
    case Operator.LTE:
      return DatalligatorOperator.lte;
    case Operator.NOT_CONTAINS:
      return DatalligatorOperator.notContains;
    case Operator.NOT_EQUALS:
      return DatalligatorOperator.notEquals;
    case Operator.NOT_SET:
      return DatalligatorOperator.notSet;
    case Operator.SET:
      return DatalligatorOperator.set;
    default:
      return DatalligatorOperator.equals;
  }
}

export function isStringTuple(value: unknown[]): value is [string, string] {
  if (typeof value[0] !== "string" || typeof value[1] !== "string") {
    return false;
  }

  return true;
}
